import { CssAnimation } from '_ui-core-js/React/components/CssAnimation.jsx';
import { multiplier } from '_ui-core-js/utilities/multiplier.js';
import React, { Fragment } from 'react';
import propTypes from 'prop-types';

export function VehicleDetails(props) {

  const block = props.block;
  const modelNameLetters = props.modelBaseName.split('');

  return (
    <Fragment>
      <CssAnimation
      enter={{name: 'short-slide-up-fade-in', duration: 1, delay: '0.75, hidden'}}
      exit={{name: 'fade-out', duration: 0.25, delay: 0}}
      triggerEnter={props.configuratorActive}
      triggerExit={!props.configuratorActive}
      renderView={props.configuratorActive}
      removeViewOnExit={true}
      >
      <div className={`${block}__heading`}>
        <CssAnimation 
        enter={{name: 'slide-up-fade-in', duration: 0.75, delay: '0.75, hidden'}} 
        triggerEnter={true} 
        retrigger={[props.modelName, {delay: '0, hidden'}]}
        >
        <div className='h2' key={'model-name'}>{props.modelName}</div>
        <div className='h6'>{props.description}</div>
        </CssAnimation>
      </div>
      </CssAnimation>

      <div className={`${block}__model-name-background`}>
      {
        [...Array(4).fill('')].map((_, index) => (
          <CssAnimation
          key={`model-name-letters-${index}`} 
          enter={{name: 'long-slide-up-fade-in', duration: 0.75, delay: `${multiplier(index, 0.25, 0.75)}, hidden`}} 
          triggerEnter={props.configuratorActive}
          renderView={props.configuratorActive}
          retrigger={[props.modelName, {delay: `${multiplier(index, 0.2, 0)}, hidden`}]}
          > 
          { 
            modelNameLetters[index] ? 
            <span className={`${block}__model-name-background--letter`}>{modelNameLetters[index]}</span> :
            <span className={`${block}__model-name-background--animation-placeholder`}></span>
          }
          </CssAnimation>
        ))
      }
      </div>
    </Fragment>
  )
};

VehicleDetails.propTypes = {
  block: propTypes.string.isRequired,
  configuratorActive: propTypes.bool.isRequired,
  modelName: propTypes.string.isRequired,
  description: propTypes.string.isRequired
};
